import { GlobalResponseObject } from "../../global-response-object";
import { CategoryWiseActAndBudgetForLastThreeYrsDetails } from "./categoryWiseActAndBudgetForLastThreeYrs-details";


export class CategoryWiseActAndBudgetForLastThreeYrsResponse extends GlobalResponseObject{
data?:CategoryWiseActAndBudgetForLastThreeYrsDetails[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:CategoryWiseActAndBudgetForLastThreeYrsDetails[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}